import { ActivityLog, CommentState } from "../.."

export const isCommentEntity = (entity: ActivityLog | CommentState) => {
    return entity.hasOwnProperty('item')
}
export const getCommentDate = (commentState: CommentState): string => {
    return commentState.item.dateTime
}
export const getActivityLogDate = (activityLog: ActivityLog): string => {
    return activityLog.dateTime
}
export const sortCommentsWithLog = (commentsWithLog: (CommentState | ActivityLog)[], isRevert?: boolean) => {
    const c = commentsWithLog.sort((a, b)=> {
        const isCommentA = isCommentEntity(a)
        const isCommentB = isCommentEntity(b)

        const timeA = isCommentA ? new Date(getCommentDate(a as CommentState)).getTime() : new Date(getActivityLogDate(a as ActivityLog)).getTime() - 1000
        const timeB = isCommentB ? new Date(getCommentDate(b as CommentState)).getTime() : new Date(getActivityLogDate(b as ActivityLog)).getTime() - 1000
        return timeA - timeB 
    })
    if(!isRevert) return c
    return c.reverse()
}

export const formatActivityText = (text: string) => {
    const [firstWord, ...rest] = text.split('_');
    const firstWordCapitalized = firstWord.charAt(0).toUpperCase() + firstWord.slice(1)
    return [firstWordCapitalized, ...rest].join(" ")
}

export const DIVIDE_COOMENTS_LENGTH = 10
export const INITIAL_DIVIDE_COMMENTS_LENGTH = 5

export const getPartFromComments = (step: number, sorted: (ActivityLog | CommentState)[], isRevert?: boolean) => {
    const len = step === 0 ? INITIAL_DIVIDE_COMMENTS_LENGTH : DIVIDE_COOMENTS_LENGTH
    const nextStep = step === 0 ? 1 : step
    if(!!isRevert) return sorted.slice(0, 1 * nextStep * len)
    return sorted.slice(-1 * nextStep * len)
}